"use client";

import * as React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

/* -------------------------------------------
 * ThemedTabsList
 * ------------------------------------------- */

type ThemedTabsListProps = React.ComponentProps<typeof TabsList>;

export function ThemedTabsList({ className, ...props }: ThemedTabsListProps) {
  return (
    <TabsList
      className={cn(
        // Container pill
        "relative inline-flex rounded-full p-1 space-x-1",
        "bg-brand-gradient backdrop-blur",

        // Subtle elevation
        "border border-theme shadow-sm",

        // Prevent layout jump
        "h-10",

        className
      )}
      {...props}
    />
  );
}

/* -------------------------------------------
 * ThemedTabsTrigger
 * ------------------------------------------- */

type ThemedTabsTriggerProps = React.ComponentProps<typeof TabsTrigger>;

export function ThemedTabsTrigger({
  className,
  ...props
}: ThemedTabsTriggerProps) {
  return (
    <TabsTrigger
      className={cn(
        // Base pill
        "relative z-10 rounded-full px-6 py-2",
        "text-sm font-semibold",

        // Motion
        "transition-all duration-200 ease-out",

        // Inactive
        "text-black/70 hover:text-black",

        // Active
        "data-[state=active]:bg-white",
        "data-[state=active]:text-black",
        "data-[state=active]:shadow-theme",
        "hover:bg-white/50",

        // Accessibility
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme",

        className
      )}
      {...props}
    />
  );
}
